import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';

interface IProps {
  id: string;
  enabled?: boolean;
}

const useSingle = ({ id, enabled = true }: IProps) => {
  const query = useQuery({
    queryKey: ['teams', 'single', id],
    queryFn: async () => {
      const response = await Api.single(id);
      return response.data.data;
    },
    enabled: enabled && Boolean(id),
  });

  return {
    team: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useSingle;
